import { UserApi } from 'shared/api/UserApi'
import { setLocalStore } from 'shared/lib/local-store'

import { ClientStateValue, SentSettingOfUser } from './user'
import userStore from './user-store'

const normalizeClientStateValue = (value: ClientStateValue | undefined) => {
  if (value === undefined || value === null || value === '') return ''
  if (typeof value === 'string') return value

  return JSON.stringify(value)
}

export const getSettingForApp = async (
  deviceId: string,
  isWidgetSearch?: boolean,
) => {
  setLocalStore('mTravelDeviceId', deviceId)

  try {
    const { data: userSettings } = await UserApi.getAppSettings()

    userStore.setUserSettings(userSettings?.data ?? null, isWidgetSearch)
  } catch (e) {
    userStore.setUserSettings(null)
    new Error('[Error on get app settings]')
  }
}

export const setSettingForApp = async (
  settings: Partial<SentSettingOfUser>,
) => {
  const { key, value } = settings

  if (
    key &&
    value !== undefined &&
    normalizeClientStateValue(userStore.client_state[key]) ===
      normalizeClientStateValue(value)
  ) {
    return
  }

  if (key && value !== undefined) {
    userStore.setClientStateValue(key, value)
  }

  try {
    const { data: userSettings } = await UserApi.patchAppSettings(settings)

    userStore.setUserSettings(userSettings?.data)
  } catch (e) {
    throw new Error('[Error on set app settings]')
  }
}
